


































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { ReopenAccountUtilityUsers } from "@/admin/route-names";
import { UmbAccountOpenerTitle, UmbAccountOpenerSubtitle } from "@/admin/constants";
import { UmbReopenAccountRequest } from "@/admin/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePartnerStore } from "@/admin/store/partner";
import { useUtilityStore } from "@/admin/store/utility";
import { useUmbAccountUserSearchStore } from "@/admin/store/umbAccountUserSearch";

@Component
export default class AdminReopenUmbAccount extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  partnerStore = usePartnerStore();
  utilityStore = useUtilityStore();
  umbAccountUserSearchStore = useUmbAccountUserSearchStore();

  title = UmbAccountOpenerTitle;
  subtitle = UmbAccountOpenerSubtitle;
  updateFormInSubmit = false;

  request: UmbReopenAccountRequest = {
    cognitoUsername: "",
    tpaId: ""
  };

  formModel = {
    email: "",
    firstName: "",
    lastName: "",
    cognitoUsername: ""
  };

  @Prop()
  umbAccountUserId: number;

  created () {
    this.fetchUser();
  }

  mounted () {
    if (!this.partnerStore.areTpaIdsLoaded) {
      this.partnerStore.getTpaIds();
    }
  }

  @Watch("umbAccountUserId")
  fetchUser () {
    this.resetForm();
    this.umbAccountUserSearchStore.loadUser(this.umbAccountUserId)
      .then(user => {
        this.formModel = {
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          cognitoUsername: user.cognitoUsername
        };
      });
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();
    this.$validator.validateAll()
      .then(isValid => {
        if (this.updateFormInSubmit || !isValid) {
          return;
        }

        this.updateFormInSubmit = true;
        this.reopenAccount();
      });
  }

  onResetForm () {
    this.$router.push({ name: ReopenAccountUtilityUsers });
    this.umbAccountUserSearchStore.reset();
  }

  reopenAccount () {
    this.request.cognitoUsername = this.formModel.cognitoUsername;
    this.utilityStore.reopenUmbAccount(this.request)
      .then(() => {
        this.$router.push({ name: ReopenAccountUtilityUsers });
        this.notifierStore.setSuccess(`${this.formModel.firstName} ${this.formModel.lastName}'s information has been saved.`);
        this.umbAccountUserSearchStore.reset();
      })
      .finally(() => this.updateFormInSubmit = false);
  }

  get tpaIdSelectOptions () {
    return this.partnerStore.tpaIds.map(x => {
      return {
        value: x,
        text: x
      };
    });
  }

  resetForm () {
    this.formModel = {
      email: "",
      firstName: "",
      lastName: "",
      cognitoUsername: ""
    };
  }
}
